import React from "react";

/**
 * Grey "SLA configured" pill tag.
 *
 * Reuses the exact markup and grey CSS classes used for the `no_sla`/`closed`
 * variants in SlaTaskRow so it matches the At Risk / Upcoming badge design in
 * the SLA Monitor feature (same shape, size, and typography — just grey).
 *
 * Intentionally NOT wired into STATUS_BADGE (which is keyed by the SlaStatus
 * enum) to avoid polluting that typed map with a non-status key.
 */
const SlaConfiguredTag = () => (
  <span className="inline-block px-2 py-0 text-11 font-semibold rounded-full whitespace-no-wrap bg-black-10 text-black-60 border border-black-20">
    SLA
  </span>
);

export default SlaConfiguredTag;
